import { PatchNotes } from './entity';
import { CURRENT_PATCH_NOTES, PATCH_NOTES, PatchNotesEntry } from './patchNotes';
import { getTokenSubject } from '../utils/auth';

export class PatchNotesService {
  getList() {
    return PATCH_NOTES;
  }

  getCurrent() {
    return CURRENT_PATCH_NOTES;
  }

  getEntry(version: string) {
    return PATCH_NOTES.find((entry) => entry.version === version);
  }

  hasSeen(entry: PatchNotesEntry) {
    return localStorage.getItem(this.getStorageKey(entry.version)) === 'true';
  }

  markSeen(entry: PatchNotesEntry | PatchNotes) {
    localStorage.setItem(this.getStorageKey(entry.version), 'true');
  }

  async load(entry: PatchNotesEntry, shouldShow: boolean): Promise<PatchNotes> {
    const response = await fetch(entry.file, { cache: 'no-cache' });
    const content = response.ok
      ? await response.text()
      : '## Patchnotes\n\nPatchnotes konnten nicht geladen werden.';

    return {
      id: String(entry.version),
      version: entry.version,
      title: entry.title,
      content,
      should_show: shouldShow
    };
  }

  private getStorageKey(version: string) {
    const user = getTokenSubject().toLowerCase() || 'anonymous';

    return `patchnotes_seen_${user}_v${version}`;
  }
}
